<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="false">
  <p style="color: white"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>

<!-- สืบค้นข้อมูลชาวไร่  -->
<div class="card ">
  <div class="card-header bg-info" sticky>
    <h3 class="card-title">สืบค้นข้อมูลชาวไร่ </h3>
    <div class="card-tools">
      <button type="button" class="btn btn-tool" data-card-widget="collapse">
        <i class="fas fa-minus"></i>
      </button>
    </div>
    <ul class="nav nav-pills mb-3 d-flex align-items-center" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <a class="btn btn-outline-secondary" [ngClass]="{'active':id_l == 1}" (click)="id_l=1">แบบที่1</a>
      </li>
      <li class="nav-item">
        <a class="btn btn-outline-secondary" [ngClass]="{'active':id_l == 2}" (click)="id_l=2">แบบที่2</a>
      </li>
    </ul>
  </div>

  <div class="card-body" [hidden]="id_l!=1">
    <div class="row justify-content-center align-items-center" sticky>
      <div class="col-auto align-content-around" style="text-align:center">
        <mat-form-field class="example-form-field" appearance="outline" style="width: 230px;">
          <mat-label> ค้นหาชื่อชาวไร่หรือเลขโควตา </mat-label>
          <input type="text" matInput placeholder="ชื่อ,นามสกุล,เลขโควตา" [(ngModel)]="fmtext" name="fmt" required>
          <button *ngIf="fmtext" matSuffix mat-icon-button aria-label="Clear" (click)="fmtext=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field class="example-form-field" appearance="outline" style="width: 150px;"
          *ngIf="farmmerdatalist.length>0">
          <mat-label> กรอง : </mat-label>
          <input type="text" matInput placeholder="ค้นหาจากตาราง ที่นี่..." [(ngModel)]="txtSearch" name="txtS">
          <button *ngIf="txtSearch" matSuffix mat-icon-button aria-label="Clear" (click)="txtSearch=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="col-auto align-content-around" style="text-align:center">
        <button mat-raised-button color="primary" (click)="getfarmmerdata();" *ngIf="fmtext.length>0">ค้นหา</button>
      </div>
    </div>

    <div class="table-responsive p-2">
      <table class="table table-head-fixed table-hover table-striped text-nowrap table-bordered border-primary"
        style="width:100%">
        <thead>
          <tr style="text-align:center">
            <th> รหัสชาวไร่</th>
            <th class="sticky-col"> ชื่อ - สกุล</th>
            <th> เบอร์ติดต่อ</th>
            <th> ที่อยู่ </th>
            <th> โซน </th>
            <th> นสส</th>
            <th> กลุ่ม</th>
            <th> 63/64 <br> พื้นที่/อ้อยเข้า/yield</th>
            <th> 64/65 <br> พื้นที่/อ้อยเข้า/yield</th>
            <th> 65/66 <br> พื้นที่/อ้อยเข้า/yield</th>
            <th> 66/67 <br> พื้นที่/อ้อยเข้า/yield</th>
            <th> 67/68 <br> พื้นที่/อ้อยเข้า/yield</th>
            <th> 68/69 <br> พื้นที่/อ้อยเข้า/yield</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of farmmerdatalist | filter:txtSearch ;" style="text-align:center">
            <td>{{item.fmcode_b1}}</td>
            <td class="sticky-col" style="text-align:left">{{item.fmname}}</td>
            <td>{{item.tel}}</td>
            <td>เลขที่ {{item.homeno}} หมู่ {{item.moo}} บ. {{item.namemoo}} <br>
              ต. {{item.district}} อ.{{item.county}} จ. {{item.province}}</td>
            <td>{{item.supzone}}</td>
            <td>{{item.supcode}}</td>
            <td>{{item.groupcode}}</td>
            <td>{{item.area6364|number:'1.1-2'}} / {{item.wgt6364|number:'1.1-2'}} / {{item.yield6364|number:'1.1-2'}}
            </td>
            <td>{{item.area6465|number:'1.1-2'}} / {{item.wgt6465|number:'1.1-2'}} / {{item.yield6465|number:'1.1-2'}}
            </td>
            <td>{{item.area6566|number:'1.1-2'}} / {{item.wgt6566|number:'1.1-2'}} / {{item.yield6566|number:'1.1-2'}}
            </td>
            <td>{{item.area6667|number:'1.1-2'}} / {{item.wgt6667|number:'1.1-2'}} / {{item.yield6667|number:'1.1-2'}}
            </td>
            <td>{{item.area6768|number:'1.1-2'}} / {{item.wgt6768|number:'1.1-2'}} / {{item.yield6768|number:'1.1-2'}}
            </td>
            <td>{{item.area6869|number:'1.1-2'}} / {{item.wgt6869|number:'1.1-2'}} / {{item.yield6869|number:'1.1-2'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="card-body" [hidden]="id_l!=2">
    <table id="datatable" class="display" style="width:100% ;text-align: center;"> </table>
  </div>
</div>
<app-footer></app-footer>